'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function noop(args) {}
;
var Split = {
    constructor: function constructor() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var callbacks = {
            getEditorState: noop,
            setEditorState: noop
        };
        return {
            name: '|',
            callbacks: callbacks,
            component: _react2["default"].createElement('span', { className: 'editor-icon-split' })
        };
    },

    config: {}
};
exports["default"] = Split;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-basic-style@0.3.6@rc-editor-plugin-basic-style/lib/Spilit/index.js
// module id = 122
// module chunks = 0 1 2